import React, { useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import ReactSelect from "react-select";
import {
  useFilters,
  useGlobalFilter,
  usePagination,
  useTable,
} from "react-table";
import { GlobalFilter } from "../components/table/FilteringTable/GlobalFilter";
import PageTitle from "../layouts/PageTitle";
//import './table.css';
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import {
  addApplicationUser,
  deleteApplicationUser,
  editApplicationUser,
  getApplicationUsers,
  resetUserPassword,
} from "../.././services/UserService";
import { getAssesmentsTemplates } from "../../services/AssesmentTemplateService";
import {
  addAssignment,
  deleteAssignment,
  getUserAssignments,
} from "../../services/AssigmentService";
import { ColumnFilter } from "../components/table/FilteringTable/ColumnFilter";
import "../components/table/FilteringTable/filtering.css";
import { canImpersonate, startViewAs } from "../../services/ViewAsService";

const ROLEJOB_OPTIONS = [
  { value: "Role 2", label: "Role 2" },
  { value: "Role 3", label: "Role 3" },
  { value: "Role 4", label: "Role 4" },
  { value: "Role 5", label: "Role 5" },
  { value: "Role 6", label: "Role 6" },
  { value: "admin", label: "Admin" },
];

// Sentinel for filtering users that have no rolejob set.
const NO_ROLEJOB = "__none__";

const RolejobColumnFilter = ({ column }) => {
  const { filterValue, setFilter } = column;
  return (
    <div>
      <select
        className="form-control input-search"
        value={filterValue || ""}
        onChange={(e) => setFilter(e.target.value || undefined)}
      >
        <option value="">All</option>
        {ROLEJOB_OPTIONS.map((item) => (
          <option key={item.value} value={item.value}>
            {item.label}
          </option>
        ))}
        <option value={NO_ROLEJOB}>No role</option>
      </select>
    </div>
  );
};

// Random 12-char password that satisfies validatePassword (upper, lower, digit, symbol).
const generatePassword = () => {
  const sets = [
    "ABCDEFGHJKLMNPQRSTUVWXYZ",
    "abcdefghjkmnpqrstuvwxyz",
    "23456789",
    "!@#$%&*?",
  ];
  const all = sets.join("");
  const pick = (chars) => chars[Math.floor(Math.random() * chars.length)];
  const chars = sets.map(pick);
  while (chars.length < 12) chars.push(pick(all));
  // shuffle so the required characters are not always in the same positions
  for (let i = chars.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [chars[i], chars[j]] = [chars[j], chars[i]];
  }
  return chars.join("");
};

const filterRolejob = (rows, id, filterValue) =>
  rows.filter((row) => {
    const value = row.values[id];
    if (filterValue === NO_ROLEJOB) return !value;
    return value === filterValue;
  });

export const Users = () => {
  const COLUMNS = [
    {
      Header: "name",
      Footer: "name",
      accessor: "name",
      Filter: ColumnFilter,
      //disableFilters: true,
    },
    {
      Header: "email",
      Footer: "email",
      accessor: "email",
      Filter: ColumnFilter,
    },
    {
      Header: "role",
      Footer: "role",
      accessor: "role",
      Cell: ({ value }) => {
        if (value) {
          const role = roles.find((role) => role.value === value);
          return (
            <span
              style={{ backgroundColor: "#da0a2a" }}
              className="badge badge-warning"
            >
              {role?.label}
            </span>
          );
        } else return "";
      },
      Filter: ColumnFilter,
    },
    {
      Header: "Role (job)",
      Footer: "Role (job)",
      accessor: "rolejob",
      Cell: ({ value }) => {
        if (value) {
          const item = ROLEJOB_OPTIONS.find((o) => o.value === value);
          return (
            <span className="badge badge-info">{item?.label || value}</span>
          );
        } else return "";
      },
      Filter: RolejobColumnFilter,
      filter: filterRolejob,
    },
    {
      Header: "Country Agency",
      Footer: "Country Agency",
      accessor: "countryAgency",
      Cell: ({ value }) => {
        if (value) return value?.name;
        else return "";
      },
      Filter: ColumnFilter,
    },
    {
      Header: "Agency",
      Footer: "Agency",
      accessor: "agency",
      Cell: ({ value }) => {
        if (value) return value?.name;
        else return "";
      },
      Filter: ColumnFilter,
    },
    {
      Header: "action",
      Footer: "action",
      accessor: "action",
      Cell: (data) => {
        return (
          <div className="d-flex">
            <Link
              className="btn btn-secondary	 shadow btn-xs sharp me-2"
              onClick={(event) => handleEditClick(event, data.row.original)}
              to="#"
            >
              <i className="fas fa-pen"></i>
            </Link>
            <Link
              className="btn btn-warning shadow btn-xs sharp me-2"
              title={`Reset password for ${data.row.original.name}`}
              onClick={(event) =>
                handleResetPasswordClick(event, data.row.original)
              }
              to="#"
            >
              <i className="fa fa-key"></i>
            </Link>
            <Link
              className="btn btn-danger shadow btn-xs sharp"
              onClick={() => handleDeleteClick(data.row.original.id)}
              to="#"
            >
              <i className="fa fa-trash"></i>
            </Link>
            {canImpersonate(user) && (
              <Link
                className="btn btn-info shadow btn-xs sharp ms-2"
                title={`View assessments as ${data.row.original.name}`}
                onClick={(event) =>
                  handleViewAsClick(event, data.row.original)
                }
                to="#"
              >
                <i className="fa fa-eye"></i>
              </Link>
            )}
          </div>
        );
      },
      Filter: ColumnFilter,
    },
  ];
  const user = useSelector((state) => state.auth.auth);
  const [roles, setRoles] = React.useState([
    { value: "agent", label: "Agent" },
    { value: "agency", label: "Agency" },
    { value: "countryAgency", label: "Country Agency" },
    { value: "admin", label: "Admin" },
  ]);
  const [users, setUsers] = useState([]);

  // edit  data
  const [editFormData, setEditFormData] = useState({
    name: "",
    department: "",
    gender: "",
    education: "",
    mobile: "",
    email: "",
  });
  //Modal box
  const [addCard, setAddCard] = useState(false);

  //Edit start
  const [editCard, setEditCard] = useState(false);
  const [editAssignments, setEditAssignments] = useState([]);
  const [editAccessForm, setEditAccessForm] = useState([]);
  const [accessUserToAdd, setAccessUserToAdd] = useState(null);
  // Edit function editable page loop
  const [editContentId, setEditContentId] = useState(null);
  const [assesmentTemplate, setAssesmentTemplate] = useState([]);
  const [selectedAssesmentTemplate, setSelectedAssesmentTemplate] = useState(
    []
  );

  const [countryAgency, setCountryAgency] = useState([]);
  const [agency, setAgency] = useState([]);

  // Add User: email the login details + download links to the new user
  const [addSendEmail, setAddSendEmail] = useState(true);

  // Reset Password modal
  const [resetCard, setResetCard] = useState(false);
  const [resetUser, setResetUser] = useState(null);
  const [resetPassword, setResetPassword] = useState("");
  const [resetSendEmail, setResetSendEmail] = useState(true);
  const [resetSaving, setResetSaving] = useState(false);

  const columns = useMemo(() => COLUMNS, []);

  React.useEffect(() => {
    if (user && user.role) {
      if (user.role === "countryAgency") {
        setRoles([
          { value: "agent", label: "Agent" },
          { value: "agency", label: "Agency" },
        ]);
      } else if (user.role === "agency") {
        setRoles([{ value: "agent", label: "Agent" }]);
      }
    }
  }, [user]);
  // const data = useMemo(() => MOCK_DATA, []);
  const tableInstance = useTable(
    {
      columns,
      data: users,
      initialState: { pageIndex: 0, pageSize: 50000 },
    },
    useFilters,
    useGlobalFilter,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    state,
    page,
    gotoPage,
    pageCount,
    pageOptions,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    setGlobalFilter,
  } = tableInstance;

  const { globalFilter, pageIndex } = state;

  // start read-only "view as" mode for the selected user
  const handleViewAsClick = (event, targetUser) => {
    event.preventDefault();
    startViewAs(targetUser);
    window.location.href = "/viewas/assessments";
  };

  // delete data
  const handleDeleteClick = (userId) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this user!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        deleteApplicationUser(userId)
          .then(() => {
            getAllUsers();
            swal("Poof! Your user has been deleted!", {
              icon: "success",
            });
          })
          .catch(() => {
            swal("Something went Wrong..!", {
              icon: "error",
            });
          });
      } else {
        swal("Your user is safe!");
      }
    });
  };

  //Add data
  const [addFormData, setAddFormData] = useState({
    name: "",
    email: "",
    role: "",
    rolejob: "",
    countryAgency: "",
    agency: "",
    password: "",
    assessmentTemplate: [],
  });

  // Add contact function
  const handleAddFormChange = (event) => {
    event.preventDefault();
    const fieldName = event.target.getAttribute("name");
    const fieldValue = event.target.value;
    const newFormData = { ...addFormData };
    newFormData[fieldName] = fieldValue;
    setAddFormData(newFormData);
  };

  const handleSelectChange = (field, value) => {
    const newFormData = { ...addFormData };
    newFormData[field] = value;
    setAddFormData(newFormData);
  };

  //Add Submit data
  const handleAddFormSubmit = async (event) => {
    event.preventDefault();
    var error = false;
    var errorMsg = "";
    if (addFormData.name === "") {
      error = true;
      errorMsg = "Please fill  name";
    } else if (addFormData.role === "") {
      error = true;
      errorMsg = "Please Select role.";
    } else if (addFormData.password === "") {
      error = true;
      errorMsg = "Please Enter Password.";
    } else if (addFormData.email === "") {
      error = true;
      errorMsg = "please fill Email";
    }
    const isWhitespace = /^(?=.*\s)/;
    if (isWhitespace.test(addFormData.password)) {
      error = true;
      errorMsg = "Password must not contain Whitespaces.";
    }

    const isContainsUppercase = /^(?=.*[A-Z])/;
    if (!isContainsUppercase.test(addFormData.password)) {
      error = true;
      errorMsg = "Password must have at least one Uppercase Character.";
    }

    const isContainsLowercase = /^(?=.*[a-z])/;
    if (!isContainsLowercase.test(addFormData.password)) {
      error = true;
      errorMsg = "Password must have at least one Lowercase Character.";
    }

    const isContainsNumber = /^(?=.*[0-9])/;
    if (!isContainsNumber.test(addFormData.password)) {
      error = true;
      errorMsg = "Password must contain at least one Digit.";
    }

    const isContainsSymbol = /^(?=.*[~`!@#$%^&*()--+={}\[\]|\\:;"'<>,.?/_₹])/;
    if (!isContainsSymbol.test(addFormData.password)) {
      error = true;
      errorMsg = "Password must contain at least one Special Symbol.";
    }

    const isValidLength = /^.{8,16}$/;
    if (!isValidLength.test(addFormData.password)) {
      error = true;
      errorMsg = "Password must be 8-16 Characters Long.";
    }
    if (!error) {
      const newContent = {
        name: addFormData.name,
        email: addFormData.email,
        password: addFormData.password,
        role: addFormData?.role?.value,
        rolejob: addFormData?.rolejob?.value || "",
        countryAgency:
          addFormData?.role?.value === "agent"
            ? addFormData?.agency?.countryAgency.id
            : addFormData?.countryAgency?.id,
        agency: addFormData?.agency?.id,
        sendEmail: addSendEmail,
      };

      await addApplicationUser(newContent)
        .then(async (user) => {
          if (
            addFormData.assessmentTemplate &&
            addFormData.assessmentTemplate.length > 0
          ) {
            for (let i = 0; i < addFormData.assessmentTemplate.length; i++) {
              let assementItem = addFormData.assessmentTemplate[i];
              const newContent = {
                assesmentUser: user.id,
                assessmentTemplate: assementItem._id,
                notes: "",
              };
              await addAssignment(newContent).catch((err) => {
                swal(err.response.data.message, { icon: "error" });
              });
            }
          }
          getAllUsers();
          setAddCard(false);
          if (addSendEmail && !user.emailSent) {
            swal(
              "User added, but email failed",
              `The account was created but the details could not be emailed to ${newContent.email}.\n\n${user.emailError || ""}`,
              "warning"
            );
          } else {
            swal(
              "User added successfully!",
              addSendEmail
                ? `Login details emailed to ${newContent.email}.`
                : "",
              "success"
            );
          }
          setAddSendEmail(true);
          setAddFormData({
            name: "",
            email: "",
            role: "",
            rolejob: "",
            countryAgency: "",
            agency: "",
            password: "",
          });
        })
        .catch((err) => {
          swal(err.response.data.message, { icon: "error" });
        });
    } else {
      swal("Oops", errorMsg, "error");
    }
  };

  // Edit function button click to edit
  const handleEditClick = (event, content) => {
    event.preventDefault();
    setEditContentId(content.id);
    const formValues = {
      name: content.name,
      role: roles.find((item) => item.value === content.role),
      rolejob: ROLEJOB_OPTIONS.find((item) => item.value === content.rolejob),
      countryAgency: content.countryAgency,
      countryAgencies: (content.countryAgencies || [])
        .map((cid) => {
          // populated by the API: use the object as-is
          if (cid && typeof cid === "object" && (cid.id || cid._id)) {
            return { ...cid, id: cid.id || cid._id };
          }
          return (
            countryAgency.find((item) => item.id === cid) ||
            users.find((item) => item.id === cid)
          );
        })
        .filter(Boolean),
      agency: content.agency,
      email: content.email,
      password: "",
      assessmentTemplate: [],
    };
    setEditFormData(formValues);
    setEditAssignments([]);
    loadUserAssignments(content.id);
    // ongoing access: users whose assessments this user may also see/edit
    const access = (content.assessorAccess || []).map((a) => {
      const uid = (a.user && (a.user.id || a.user._id || a.user)) || a.user;
      const u = users.find((item) => item.id === uid) || { name: "Unknown" };
      return {
        user: uid,
        name: u.name,
        canView: a.canView !== false,
        canEdit: !!a.canEdit,
      };
    });
    setEditAccessForm(access);
    setAccessUserToAdd(null);
    setEditCard(true);
  };

  const handleAddAccessUser = () => {
    if (!accessUserToAdd) return;
    const uid = accessUserToAdd.id || accessUserToAdd._id;
    if (uid === editContentId) {
      swal("Not allowed", "A user cannot be granted access to itself.", "info");
      return;
    }
    if (editAccessForm.some((a) => a.user === uid)) {
      swal("Already added", "That user is already granted.", "info");
      return;
    }
    setEditAccessForm([
      ...editAccessForm,
      { user: uid, name: accessUserToAdd.name, canView: true, canEdit: true },
    ]);
    setAccessUserToAdd(null);
  };

  const handleRemoveAccessUser = (uid) => {
    setEditAccessForm(editAccessForm.filter((a) => a.user !== uid));
  };

  const toggleAccessPermission = (uid, field) => {
    setEditAccessForm(
      editAccessForm.map((a) =>
        a.user === uid ? { ...a, [field]: !a[field] } : a
      )
    );
  };

  // load the assessment-template assignments for the user being edited
  const loadUserAssignments = (userId) => {
    getUserAssignments(userId)
      .then((res) => {
        const list = (Array.isArray(res) ? res : [])
          .filter((a) => a.assessmentTemplate)
          .map((a) => ({
            id: a._id || a.id,
            roleAssigned: !!a.roleAssigned,
            templateName: a.assessmentTemplate.name,
            notes: a.notes || "",
          }));
        setEditAssignments(list);
      })
      .catch(() => setEditAssignments([]));
  };

  // remove one direct assignment (CRUD assessor)
  const handleRemoveAssignment = (assignmentId) => {
    deleteAssignment(assignmentId)
      .then(() => {
        loadUserAssignments(editContentId);
        swal("Removed", "Assessment removed from user", "success");
      })
      .catch((err) => {
        swal(
          (err.response && err.response.data && err.response.data.message) ||
            "Could not remove assessment",
          { icon: "error" }
        );
      });
  };

  //update data function
  const handleEditFormChange = (event) => {
    event.preventDefault();
    const fieldName = event.target.getAttribute("name");
    const fieldValue = event.target.value;
    const newFormData = { ...editFormData };
    newFormData[fieldName] = fieldValue;
    setEditFormData(newFormData);
  };

  const handleEditSelectChange = (field, value) => {
    const newFormData = { ...editFormData };
    newFormData[field] = value;
    setEditFormData(newFormData);
  };

  // validate a password only when one is being set (edit is optional)
  const validatePassword = (pwd) => {
    if (/^(?=.*\s)/.test(pwd)) return "Password must not contain Whitespaces.";
    if (!/[A-Z]/.test(pwd))
      return "Password must have at least one Uppercase Character.";
    if (!/[a-z]/.test(pwd))
      return "Password must have at least one Lowercase Character.";
    if (!/[0-9]/.test(pwd)) return "Password must contain at least one Digit.";
    if (!/[~`!@#$%^&*()--+={}\[\]|\\:;"'<>,.?/_₹]/.test(pwd))
      return "Password must contain at least one Special Symbol.";
    if (!/^.{8,16}$/.test(pwd)) return "Password must be 8-16 Characters Long.";
    return null;
  };

  // add newly selected templates as assignments to the edited user
  const addSelectedTemplatesToUser = async (userId, templates) => {
    if (!templates || templates.length === 0) return;
    for (let i = 0; i < templates.length; i++) {
      const tpl = templates[i];
      await addAssignment({
        assesmentUser: userId,
        assessmentTemplate: tpl._id,
        notes: "",
      }).catch((err) => {
        swal(
          (err.response && err.response.data && err.response.data.message) ||
            "Could not assign assessment",
          { icon: "error" }
        );
      });
    }
  };

  // edit form data submit
  const handleEditFormSubmit = async (event) => {
    event.preventDefault();
    const editedContent = {
      name: editFormData.name,
      email: editFormData.email,
      role: editFormData?.role?.value || undefined,
      rolejob: editFormData?.rolejob?.value || "",
      countryAgency: editFormData?.countryAgency?.id || undefined,
      countryAgencies: (editFormData.countryAgencies || []).map(
        (c) => c.id || c._id || c
      ),
      agency: editFormData?.agency?.id || undefined,
      assessorAccess: editAccessForm.map((a) => ({
        user: a.user,
        canView: a.canView,
        canEdit: a.canEdit,
      })),
    };
    // only change the password when the admin typed a new one
    if (editFormData.password && editFormData.password.length > 0) {
      const pwdError = validatePassword(editFormData.password);
      if (pwdError) {
        swal("Oops", pwdError, "error");
        return;
      }
      editedContent.password = editFormData.password;
    }
    try {
      await editApplicationUser(editContentId, editedContent);
      await addSelectedTemplatesToUser(
        editContentId,
        editFormData.assessmentTemplate
      );
      getAllUsers();
      swal("Good job!", "Successfully Updated", "success");
      setEditCard(false);
      setEditContentId(null);
      setEditAssignments([]);
      setEditAccessForm([]);
      setAccessUserToAdd(null);
      setEditFormData({
        name: "",
        email: "",
        role: "",
        rolejob: "",
        countryAgency: "",
        countryAgencies: [],
        agency: "",
        password: "",
        assessmentTemplate: [],
      });
    } catch (err) {
      swal(
        (err.response && err.response.data && err.response.data.message) ||
          "Update failed",
        { icon: "error" }
      );
    }
  };

  // Reset Password: open modal with a generated password pre-filled
  const handleResetPasswordClick = (event, content) => {
    event.preventDefault();
    setResetUser(content);
    setResetPassword(generatePassword());
    setResetSendEmail(true);
    setResetCard(true);
  };

  const closeResetCard = () => {
    setResetCard(false);
    setResetUser(null);
    setResetPassword("");
  };

  const handleResetPasswordSubmit = async (event) => {
    event.preventDefault();
    if (!resetUser) return;
    const pwdError = validatePassword(resetPassword || "");
    if (pwdError) {
      swal("Oops", pwdError, "error");
      return;
    }
    setResetSaving(true);
    try {
      const res = await resetUserPassword(
        resetUser.id,
        resetPassword,
        resetSendEmail
      );
      closeResetCard();
      if (resetSendEmail && !res.emailSent) {
        swal(
          "Password reset, but email failed",
          `The new password was saved but could not be emailed to ${resetUser.email}.\n\nPassword: ${resetPassword}\n\n${res.emailError || ""}`,
          "warning"
        );
      } else if (resetSendEmail) {
        swal(
          "Password reset",
          `New password saved and emailed to ${resetUser.email}.`,
          "success"
        );
      } else {
        swal(
          "Password reset",
          `New password for ${resetUser.email}:\n\n${resetPassword}\n\nIt was not emailed — pass it on to the user yourself.`,
          "success"
        );
      }
    } catch (err) {
      swal(
        (err.response && err.response.data && err.response.data.message) ||
          "Password reset failed",
        { icon: "error" }
      );
    } finally {
      setResetSaving(false);
    }
  };

  //Cencel button to same data
  const handleCancelClick = () => {
    setEditContentId(null);
    setEditCard(false);
    setEditAccessForm([]);
    setAccessUserToAdd(null);
  };

  const getAllUsers = () => {
    getApplicationUsers()
      .then((res) => {
        setUsers(res.results.filter((item) => item.id !== user.userId));
        setCountryAgency(
          res.results.filter((item) => item.role === "countryAgency")
        );
        setAgency(res.results.filter((item) => item.role === "agency"));
      })
      .catch((e) => {
        swal(e.response.data.message, { icon: "error" });
      });
  };

  React.useEffect(() => {
    getAllUsers();
    getAssesmentsTemplates().then((res) => setAssesmentTemplate(res));
  }, []);

  return (
    <>
      <PageTitle activeMenu="All Users" motherMenu="Users" />
      <Modal className="modal fade" show={addCard} onHide={setAddCard}>
        <div className="" role="document">
          <div className="">
            <form>
              <div className="modal-header">
                <h4 className="modal-title fs-20">Add User</h4>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setAddCard(false)}
                  data-dismiss="modal"
                >
                  <span></span>
                </button>
              </div>
              <div className="modal-body">
                <i
                  className="flaticon-cancel-12 close"
                  data-dismiss="modal"
                ></i>
                <div className="add-contact-box">
                  <div className="add-contact-content">
                    <div className="form-group mb-3">
                      <label className="text-black font-w500">Name</label>
                      <div className="contact-name">
                        <input
                          type="text"
                          className="form-control"
                          autoComplete="off"
                          name="name"
                          required="required"
                          onChange={handleAddFormChange}
                          placeholder="name"
                        />
                        <span className="validation-text"></span>
                      </div>
                    </div>
                    <div className="form-group mb-3">
                      <label className="text-black font-w500">Email</label>
                      <div className="contact-name">
                        <input
                          type="text"
                          className="form-control"
                          autoComplete="off"
                          name="email"
                          required="required"
                          onChange={handleAddFormChange}
                          placeholder="email"
                        />
                        <span className="validation-text"></span>
                      </div>
                    </div>
                    <div className="form-group mb-3">
                      <label className="text-black font-w500">Password</label>
                      <div className="contact-name">
                        <input
                          type="text"
                          className="form-control"
                          autoComplete="off"
                          name="password"
                          required="required"
                          onChange={handleAddFormChange}
                          placeholder="Enter Password"
                        />
                        <span className="validation-text"></span>
                      </div>
                    </div>
                    <div className="form-group mb-3">
                      <label className="text-black font-w500">Role</label>
                      <div className="contact-name">
                        <ReactSelect
                          onChange={(e) => handleSelectChange("role", e)}
                          options={roles}
                          value={addFormData.role}
                          style={{
                            lineHeight: "40px",
                            color: "#7e7e7e",
                            paddingLeft: " 15px",
                          }}
                        />
                        <span className="validation-text"></span>
                      </div>
                    </div>
                    <div className="form-group mb-3">
                      <label className="text-black font-w500">
                        Role (job)
                      </label>
                      <div className="contact-name">
                        <ReactSelect
                          name="rolejob"
                          isClearable
                          onChange={(e) => handleSelectChange("rolejob", e)}
                          options={ROLEJOB_OPTIONS}
                          value={addFormData.rolejob}
                          placeholder="Select role (Role 2…6 / Admin)"
                          style={{
                            lineHeight: "40px",
                            color: "#7e7e7e",
                            paddingLeft: " 15px",
                          }}
                        />
                        <small className="text-muted">
                          Used by per-template role assignments — user will see
                          all templates tagged with this role.
                        </small>
                      </div>
                    </div>
                    {addFormData.role &&
                      addFormData.role.value !== "countryAgency" &&
                      addFormData.role.value !== "admin" &&
                      addFormData.role.value !== "agent" && (
                        <div className="form-group mb-3">
                          <label className="text-black font-w500">
                            Country Agency
                          </label>
                          <div className="contact-name">
                            <ReactSelect
                              name="countryAgency"
                              fieldName="countryAgency"
                              onChange={(e) =>
                                handleSelectChange("countryAgency", e)
                              }
                              options={countryAgency}
                              value={addFormData.countryAgency}
                              getOptionLabel={(option) => option.name}
                              getOptionValue={(option) => option.id}
                              style={{
                                lineHeight: "40px",
                                color: "#7e7e7e",
                                paddingLeft: " 15px",
                              }}
                            />
                            <span className="validation-text"></span>
                          </div>
                        </div>
                      )}
                    {addFormData.role &&
                      addFormData.role.value !== "admin" &&
                      addFormData.role.value !== "countryAgency" &&
                      addFormData.role.value !== "agency" && (
                        <div className="form-group mb-3">
                          <label className="text-black font-w500">Agency</label>
                          <div className="contact-name">
                            <ReactSelect
                              name="agency"
                              fieldName="agency"
                              onChange={(e) => handleSelectChange("agency", e)}
                              options={agency}
                              value={addFormData.agency}
                              getOptionLabel={(option) => option.name}
                              getOptionValue={(option) => option.id}
                              style={{
                                lineHeight: "40px",
                                color: "#7e7e7e",
                                paddingLeft: " 15px",
                              }}
                            />
                            <span className="validation-text"></span>
                          </div>
                        </div>
                      )}
                    {addFormData.role.value === "agent" && (
                      <div className="form-group mb-3">
                        <label className="text-black font-w500">
                          Assement Template
                        </label>
                        <div className="contact-name">
                          <ReactSelect
                            name="assessmentTemplate"
                            fieldName="assessmentTemplate"
                            isMulti
                            onChange={(e) =>
                              handleSelectChange("assessmentTemplate", e)
                            }
                            options={assesmentTemplate}
                            value={addFormData.assessmentTemplate}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.ID}
                            style={{
                              lineHeight: "40px",
                              color: "#7e7e7e",
                              paddingLeft: " 15px",
                            }}
                          />
                          <span className="validation-text"></span>
                        </div>
                      </div>
                    )}
                    <div className="form-check mb-2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="addSendEmail"
                        checked={addSendEmail}
                        onChange={(e) => setAddSendEmail(e.target.checked)}
                      />
                      <label className="form-check-label" htmlFor="addSendEmail">
                        Email login details &amp; download links to the user
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="submit"
                  className="btn btn-primary"
                  onClick={handleAddFormSubmit}
                >
                  Add
                </button>
                <button
                  type="button"
                  onClick={() => setAddCard(false)}
                  className="btn btn-danger"
                >
                  {" "}
                  <i className="flaticon-delete-1"></i> Discard
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>

      {/* Edit User modal — choose role, change password, and CRUD assigned assessments */}
      <Modal
        className="modal fade"
        show={editCard}
        onHide={() => setEditCard(false)}
      >
        <div role="document">
          <div>
            <form>
              <div className="modal-header">
                <h4 className="modal-title fs-20">Edit User</h4>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setEditCard(false)}
                >
                  <span></span>
                </button>
              </div>
              <div className="modal-body">
                <div className="add-contact-box">
                  <div className="add-contact-content">
                    <div className="form-group mb-3">
                      <label className="text-black font-w500">Name</label>
                      <div className="contact-name">
                        <input
                          type="text"
                          className="form-control"
                          autoComplete="off"
                          name="name"
                          value={editFormData.name || ""}
                          onChange={handleEditFormChange}
                          placeholder="name"
                        />
                      </div>
                    </div>
                    <div className="form-group mb-3">
                      <label className="text-black font-w500">Email</label>
                      <div className="contact-name">
                        <input
                          type="text"
                          className="form-control"
                          autoComplete="off"
                          name="email"
                          value={editFormData.email || ""}
                          onChange={handleEditFormChange}
                          placeholder="email"
                        />
                      </div>
                    </div>
                    <div className="form-group mb-3">
                      <label className="text-black font-w500">
                        Change Password
                      </label>
                      <div className="contact-name">
                        <input
                          type="text"
                          className="form-control"
                          autoComplete="off"
                          name="password"
                          value={editFormData.password || ""}
                          onChange={handleEditFormChange}
                          placeholder="Leave blank to keep current password"
                        />
                        <small className="text-muted">
                          8-16 chars with upper, lower, number & symbol. Leave
                          empty to keep the existing password.
                        </small>
                      </div>
                    </div>
                    <div className="form-group mb-3">
                      <label className="text-black font-w500">Role</label>
                      <div className="contact-name">
                        <ReactSelect
                          onChange={(e) => handleEditSelectChange("role", e)}
                          options={roles}
                          value={editFormData.role}
                        />
                      </div>
                    </div>
                    <div className="form-group mb-3">
                      <label className="text-black font-w500">Role (job)</label>
                      <div className="contact-name">
                        <ReactSelect
                          name="rolejob"
                          isClearable
                          onChange={(e) => handleEditSelectChange("rolejob", e)}
                          options={ROLEJOB_OPTIONS}
                          value={editFormData.rolejob}
                          placeholder="Select role (Role 2…6 / Admin)"
                        />
                      </div>
                    </div>
                    <div className="form-group mb-3">
                      <label className="text-black font-w500">
                        Country Agency
                      </label>
                      <div className="contact-name">
                        <ReactSelect
                          name="countryAgency"
                          onChange={(e) =>
                            handleEditSelectChange("countryAgency", e)
                          }
                          options={countryAgency}
                          value={editFormData.countryAgency}
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option.id}
                          isClearable
                        />
                      </div>
                    </div>
                    <div className="form-group mb-3">
                      <label className="text-black font-w500">
                        Additional Country Agencies (country-wide access)
                      </label>
                      <div className="contact-name">
                        <ReactSelect
                          name="countryAgencies"
                          isMulti
                          onChange={(e) =>
                            handleEditSelectChange("countryAgencies", e || [])
                          }
                          options={countryAgency}
                          value={editFormData.countryAgencies || []}
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option.id}
                          placeholder="Grant access to more country agencies…"
                        />
                      </div>
                    </div>
                    <div className="form-group mb-3">
                      <label className="text-black font-w500">Agency</label>
                      <div className="contact-name">
                        <ReactSelect
                          name="agency"
                          onChange={(e) => handleEditSelectChange("agency", e)}
                          options={agency}
                          value={editFormData.agency}
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option.id}
                          isClearable
                        />
                      </div>
                    </div>

                    {/* CRUD assessor: current assessment assignments */}
                    <div className="form-group mb-3">
                      <label className="text-black font-w500">
                        Assigned Assessments
                      </label>
                      {editAssignments.length > 0 ? (
                        <ul className="list-group mb-2">
                          {editAssignments.map((a) => (
                            <li
                              key={a.id}
                              className="list-group-item d-flex justify-content-between align-items-center"
                            >
                              <span>
                                {a.templateName}
                                {a.roleAssigned && (
                                  <span className="badge badge-info ms-2">
                                    by role
                                  </span>
                                )}
                              </span>
                              {!a.roleAssigned && (
                                <button
                                  type="button"
                                  className="btn btn-danger btn-xs sharp"
                                  title="Remove assessment"
                                  onClick={() => handleRemoveAssignment(a.id)}
                                >
                                  <i className="fa fa-trash"></i>
                                </button>
                              )}
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <p className="text-muted mb-2">
                          No assessments assigned yet.
                        </p>
                      )}
                      <label className="text-black font-w500">
                        Add Assessments
                      </label>
                      <div className="contact-name">
                        <ReactSelect
                          name="assessmentTemplate"
                          isMulti
                          onChange={(e) =>
                            handleEditSelectChange("assessmentTemplate", e)
                          }
                          options={assesmentTemplate}
                          value={editFormData.assessmentTemplate}
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option.ID}
                          placeholder="Select assessments to add on save"
                        />
                      </div>
                    </div>

                    <hr />
                    {/* Ongoing access: this user may also see/edit assessments
                        owned by the selected users (incl. future ones) */}
                    <div className="form-group mb-3">
                      <label className="text-black font-w500">
                        Can also access assessments owned by
                      </label>
                      <small className="d-block text-muted mb-2">
                        This user will see (and, if Edit is ticked, edit) the
                        selected users' assessments — including future ones.
                      </small>
                      {editAccessForm.length > 0 ? (
                        <ul className="list-group mb-2">
                          {editAccessForm.map((a) => (
                            <li
                              key={a.user}
                              className="list-group-item d-flex justify-content-between align-items-center flex-wrap"
                            >
                              <span style={{ minWidth: "140px" }}>
                                {a.name}
                              </span>
                              <span className="d-flex align-items-center">
                                <label className="me-2 mb-0">
                                  <input
                                    type="checkbox"
                                    checked={a.canView}
                                    onChange={() =>
                                      toggleAccessPermission(a.user, "canView")
                                    }
                                  />{" "}
                                  View
                                </label>
                                <label className="me-3 mb-0">
                                  <input
                                    type="checkbox"
                                    checked={a.canEdit}
                                    onChange={() =>
                                      toggleAccessPermission(a.user, "canEdit")
                                    }
                                  />{" "}
                                  Edit
                                </label>
                                <button
                                  type="button"
                                  className="btn btn-danger btn-xs sharp"
                                  title="Remove"
                                  onClick={() => handleRemoveAccessUser(a.user)}
                                >
                                  <i className="fa fa-trash"></i>
                                </button>
                              </span>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <p className="text-muted mb-2">
                          No extra access granted.
                        </p>
                      )}
                      <div className="d-flex align-items-center">
                        <div style={{ flexGrow: 1, marginRight: "8px" }}>
                          <ReactSelect
                            placeholder="Grant access to another user's assessments…"
                            onChange={(e) => setAccessUserToAdd(e)}
                            options={users.filter(
                              (u) =>
                                u.id !== editContentId &&
                                !editAccessForm.some((a) => a.user === u.id)
                            )}
                            value={accessUserToAdd}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                          />
                        </div>
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={handleAddAccessUser}
                        >
                          Add
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="submit"
                  className="btn btn-primary"
                  onClick={handleEditFormSubmit}
                >
                  Save
                </button>
                <button
                  type="button"
                  onClick={handleCancelClick}
                  className="btn btn-danger"
                >
                  {" "}
                  <i className="flaticon-delete-1"></i> Discard
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>

      {/* Reset Password modal — set (or generate) a password and optionally email it */}
      <Modal className="modal fade" show={resetCard} onHide={closeResetCard}>
        <div role="document">
          <div>
            <form onSubmit={handleResetPasswordSubmit}>
              <div className="modal-header">
                <h4 className="modal-title fs-20">Reset Password</h4>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeResetCard}
                >
                  <span></span>
                </button>
              </div>
              <div className="modal-body">
                <div className="add-contact-box">
                  <div className="add-contact-content">
                    <p className="mb-3">
                      <b>{resetUser?.name}</b>
                      <br />
                      <span className="text-muted">{resetUser?.email}</span>
                    </p>
                    <div className="form-group mb-3">
                      <label className="text-black font-w500">
                        New Password
                      </label>
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          autoComplete="off"
                          name="resetPassword"
                          value={resetPassword}
                          onChange={(e) => setResetPassword(e.target.value)}
                          placeholder="Enter or generate a password"
                        />
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() => setResetPassword(generatePassword())}
                        >
                          <i className="fa fa-refresh me-1"></i> Generate
                        </button>
                      </div>
                      <small className="text-muted">
                        8-16 chars with upper, lower, number & symbol.
                      </small>
                    </div>
                    <div className="form-check mb-2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="resetSendEmail"
                        checked={resetSendEmail}
                        onChange={(e) => setResetSendEmail(e.target.checked)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="resetSendEmail"
                      >
                        Email the new password to {resetUser?.email}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={resetSaving}
                >
                  {resetSaving ? "Saving..." : "Reset Password"}
                </button>
                <button
                  type="button"
                  onClick={closeResetCard}
                  className="btn btn-danger"
                >
                  {" "}
                  <i className="flaticon-delete-1"></i> Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>

      <div className="card">
        <div className="card-header">
          <h4 className="card-title">Users Datatable</h4>
          <button className="btn btn-primary" onClick={() => setAddCard(true)}>
            <i className="fa fa-plus" /> Add User
          </button>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
            <div>
              <table {...getTableProps()} className="table  display">
                <thead>
                  {headerGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column) => (
                        <th {...column.getHeaderProps()}>
                          {column.render("Header")}
                          {column.canFilter ? column.render("Filter") : null}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getTableBodyProps()} className="">
                  {page.map((row) => {
                    prepareRow(row);
                    return (
                      <tr {...row.getRowProps()}>
                        {row.cells.map((cell) => {
                          return (
                            <td {...cell.getCellProps()}>
                              {" "}
                              {cell.render("Cell")}{" "}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Users;
